// extracted by mini-css-extract-plugin
module.exports = {"disclaimer__wrp":"disclaimer__wrp-OOhIw","disclaimer__icon":"disclaimer__icon-uRX_j"};